export default __webpack_public_path__ + "static/media/EKYCContinue@2x.5659c067.png";